import { styles } from './styles';

type Props = {
  buttonText: string;
};

export default function Button({ buttonText }: Props) {
  return (
    <styles.Button href="https://www.sijoitustutkimus.fi/palvelut/rahastoyhtioille/rahastojen-tietopalvelut/rahastoraportti/rahastoraporttiarkisto/">
      {buttonText}
    </styles.Button>
  );
}
